import script from "./AbsensiDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AbsensiDetail.vue?vue&type=script&setup=true&lang=js"

import "./AbsensiDetail.vue?vue&type=style&index=0&id=735863a3&scoped=true&lang=css"

import exportComponent from "/mnt/0EA9C00323D8BFD1/Code/ptbcs-quasar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-735863a3"]])

export default __exports__
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';import Ripple from 'quasar/src/directives/Ripple.js';
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToolbar,QTable,QToolbarTitle,QCard,QList,QItem,QItemSection,QSelect,QTd,QDialog,QCardSection,QInput,QCardActions,QBtn,QField});qInstall(script, 'directives', {Ripple,ClosePopup});
